module.exports = __webpack_public_path__ + "img/heroimg@2x.e489e869.png";